export default __webpack_public_path__ + "assets/fintecture-e81e53df943c427d0fec8e9794a2b5ad.png";